import { render } from "./StakePoolDetails.vue?vue&type=template&id=48900b17"
import script from "./StakePoolDetails.vue?vue&type=script&lang=js"
export * from "./StakePoolDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/StakePoolDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48900b17"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48900b17', __exports__)) {
    api.reload('48900b17', __exports__)
  }
  
  module.hot.accept("./StakePoolDetails.vue?vue&type=template&id=48900b17", () => {
    api.rerender('48900b17', render)
  })

}


export default __exports__